import { toast } from 'sonner'
import { useState } from 'react'

import { StorePersistKeys } from 'src/types'
import { useLocales } from 'src/contexts'

import { useManageMaintenanceHistory } from 'src/hooks/useManageMaintenanceHistory'

import { maintenanceDictionaryType } from 'src/features/MaintenanceHistoryCard/helpers'
import { queryClient } from 'src/features/AppProviders/constants'

export const useMaintenanceHistoryCard = () => {
  const { locale, translations } = useLocales()

  const { deleteMaintenanceHistory } = useManageMaintenanceHistory()

  const [isEditMode, setEditMode] = useState<boolean>(false)

  const handleDelete = (itemId: string): void => {
    deleteMaintenanceHistory(itemId, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [StorePersistKeys.MAINTENANCE_HISTORY],
        })
        toast(translations.maintenance.historyMaintenance.toast.success.title, {
          description:
            translations.maintenance.historyMaintenance.toast.success
              .description,
          action: {
            label:
              translations.maintenance.historyMaintenance.toast.success.action
                .label,
            onClick: () => toast.dismiss(),
          },
        })
      },
      onError: error => {
        toast(translations.maintenance.historyMaintenance.toast.error.title, {
          description:
            translations.maintenance.historyMaintenance.toast.error
              .description + error,
          action: {
            label:
              translations.maintenance.historyMaintenance.toast.error.action
                .label,
            onClick: () => toast.dismiss(),
          },
        })
      },
    })
  }

  const toggleEditMode = (): void => {
    setEditMode(prevState => !prevState)
  }

  return {
    language: locale,
    addMaintenanceLocale: translations.maintenance.addMaintenance,
    locale: translations.maintenance.historyMaintenance,
    handleDelete,
    isEditMode,
    toggleEditMode,
    maintenanceDictionary: maintenanceDictionaryType(translations.maintenance),
  }
}
